
import { mapMutations, mapActions } from 'vuex';
import countryList from './countries';
import * as types from '@/types';
import * as gapi from '~/api/g-init';
import * as userApi from '~/api/user';
import initTime from '~/plugins/initTime';

export default {
  data() {
    return {
      tab: 'bind', // bind:绑定手机号 merge-account:合并账号 merge-check:确认合并 merge-res:合并结果
      defaultAvatar:
        'https://img4.gelonghui.com/headdefault/avatar_default2.png',
      userInput: {
        countryCode: '86',
        phoneCode: '',
        phone: '',
      },
      timer: {
        bind: {
          createdAt: 0,
          id: null,
          cd: 0,
        },
      },
      errorMsg: '', // 错误消息
      errorType: '', // 错误类型
      bindRes: null, // 合并结果
      userList: ['phoneUser', 'loginUser'], // 账号列表：手机号、第三方
      users: {
        phoneUser: {},
        loginUser: {},
      },
      selectedUser: 'phoneUser', // 被选中用户
    };
  },
  computed: {
    /**
     * @description 电话号码国号
     * @returns { Array } 列表
     */
    countries() {
      return countryList;
    },
    /**
     * @description 按钮文案
     * @returns { string } 按钮文案
     */
    submitText() {
      if (this.tab === 'bind') {
        return this.$t('login.submit.bind');
      }
      return this.$t('login.submit.bind');
    },
  },
  beforeDestroy() {
    this.initData();
  },
  methods: {
    ...mapMutations('user', {
      hide: types.HIDE_LOGIN_FORM,
      updateLoginInfo: types.SET_LOGININFO,
    }),
    ...mapActions({
      updateVipMemberInfo: 'user/updateVipMemberInfo',
    }),
    initTime(t) {
      return initTime(t);
    },
    /**
     * @description 初始化数据
     */
    initData() {
      this.tab = 'bind';
      this.userInput = {
        countryCode: '86',
        phoneCode: '',
        phone: '',
      };
      this.errorMsg = '';
      this.errorType = '';
      this.bindRes = null;
    },
    /**
     * @description 验证码冷却计时器入口
     * @param { string } type 类型
     */
    startTick(type) {
      this.timer[type].id = setInterval(() => {
        this.timerTick(type);
      }, 1000);
      this.timer[type].createdAt = Date.now();
    },
    /**
     * @description 验证码冷却计时器的step函数
     * @param { string } type 类型
     */
    timerTick(type) {
      const val = Math.floor((Date.now() - this.timer[type].createdAt) / 1000);
      this.timer[type].cd = Math.max(60 - val, 0);
      if (this.timer[type].cd === 0) {
        clearInterval(this.timer[type].id);
        this.timer[type].createdAt = 0;
      }
    },
    /**
     * @description 修改当前展示页
     * @param { string } tab 页面类型
     */
    changeTab(tab) {
      this.tab = tab;
      this.clearErrorMsg();
    },
    /**
     * @description 获取电话验证码
     */
    async getPhoneCode(
      challenge = undefined,
      validate = undefined,
      seccode = undefined
    ) {
      this.clearErrorMsg();
      const { phone, countryCode } = this.userInput;
      const tab = this.tab;
      if (!phone) {
        this.errorMsg = this.$t('login.error.phone-empty');
        this.errorType = tab;
        return false;
      }
      let pros = null;
      switch (tab) {
        case 'bind': // 绑定手机号
          pros = await this.$axios(
            userApi.getFastLoginPhoneCode({
              phone,
              countryCode,
              challenge,
              validate,
              seccode,
            })
          );
          break;
        default:
          break;
      }
      if (!pros) return false;
      if (pros.statusCode === 2000) {
        // 触发了极验
        const GInit = await this.$axios(
          gapi.getGInit({
            phone,
            countryCode,
          })
        ); // 服务端获取极验初始化参数
        if (!GInit.result) return;
        initGeetest(
          {
            gt: GInit.result.gt,
            challenge: GInit.result.challenge,
            offline: !GInit.result.success,
            new_captcha: true,
            width: '100%',
            product: 'bind',
          },
          captchaObj => {
            // 准备好了
            captchaObj.onReady(() => {
              captchaObj.verify();
              captchaObj.onSuccess(() => {
                const result = captchaObj.getValidate();
                challenge = result.geetest_challenge;
                validate = result.geetest_validate;
                seccode = result.geetest_seccode;
                // 带上之前的验证的参数激活getPhoneCode 重新获取验证码
                this.getPhoneCode(challenge, validate, seccode);
              });
            });
          }
        );
      } else if (pros.statusCode === 200) {
        // 获取验证码成功
        this.startTick(tab);
      } else {
        this.errorMsg = pros.message;
        this.errorType = tab;
      }
    },
    /**
     * @description 提交绑定手机号
     */
    async submit() {
      this.clearErrorMsg();
      const { phone, countryCode, phoneCode } = this.userInput;
      const tab = this.tab;
      if (!phone) {
        this.errorMsg = this.$t('login.error.phone-empty');
        this.errorType = tab;
        return false;
      } else if (!phoneCode) {
        this.errorMsg = this.$t('login.error.phone-code-empty');
        this.errorType = 'phoneCode';
        return false;
      }
      const data = await this.$axios(
        userApi.bindPhone({
          countryCode,
          phone,
          verificationCode: phoneCode,
        })
      );
      if (data.statusCode === 200) {
        if (
          data.result &&
          data.result['phoneUser'] &&
          data.result['loginUser']
        ) {
          this.users = data.result;
          this.tab = 'merge-account';
        } else {
          // TODO: 调用同意合同接口
          this.agreeAgreement();
          this.$emit('changePage', {
            page: 'pageSuccess',
            type: 'bind',
          });
        }
      } else if (data.statusCode === 1012) {
        // 有冲突就是返回2个对象。没有冲突，直接绑定成功，返回loginUser
        // 已注册格隆汇账号，进行合并账号
        this.users = data.result;
        this.tab = 'merge-account';
      } else {
        this.errorMsg = data.message;
      }
    },
    /**
     * @description 合并账号二次确认
     */
    async mergeCheck() {
      const phoneUserId = this.users['phoneUser'].id;
      const loginUserId = this.users['loginUser'].id;
      let selectedAccount, deprecatedAccount;
      switch (this.selectedUser) {
        case 'phoneUser':
          selectedAccount = phoneUserId;
          deprecatedAccount = loginUserId;
          break;
        case 'loginUser':
          selectedAccount = loginUserId;
          deprecatedAccount = phoneUserId;
          break;
      }
      // selectedAccount:选中的用户ID号 deprecatedAccount:未选中的用户ID号
      const data = await this.$axios(
        userApi.mergeAccount({
          selectedAccount,
          deprecatedAccount,
        })
      );
      if (data.statusCode === 200) {
        this.tab = 'merge-res';
        this.bindRes = 'success';
        this.updateMyInfo();
      } else if (data.statusCode === 417) {
        this.errorMsg = data.message;
      } else {
        this.tab = 'merge-res';
        this.bindRes = 'fail';
      }
    },
    /**
     * @description 更新用户信息
     */
    updateMyInfo() {
      this.$axios(userApi.getMemberInfo()).then(res => {
        if (res.result) {
          this.updateLoginInfo(res.result);
          this.updateVipMemberInfo(res.result.vip);
          if (!res.result.agreeUserAgreement) {
            this.agreeAgreement();
          }
        }
      });
    },
    /**
     * @description 关闭弹窗
     */
    closeDialog() {
      this.hide();
    },
    /**
     * @description 调用同意合同接口（第一次登录的用户需要调用一次同意用户合同操作）
     */
    async agreeAgreement() {
      try {
        await this.$axios(userApi.agreeAgreement());
      } catch (e) {}
    },
    /**
     * @description 清除错误信息
     */
    clearErrorMsg() {
      this.errorMsg = '';
      this.errorType = '';
    },
    /**
     * @description 计算用户剩余会员时间
     * @returns { Number } 用户剩余会员时间
     */
    surplusDays(expireTimestamp) {
      const today = new Date();
      const spDays = Math.ceil(
        (expireTimestamp * 1000 - today.getTime()) / (24 * 60 * 60 * 1000)
      );
      return spDays > 0 ? spDays : '无';
    },
  },
};
